import { LayerDefinition } from './types';

export const sunriseDefinition: LayerDefinition = {
  id: 'sunrise',
  name: 'Sunrise & Sunset Scoring',
  category: 'forecast',
  categoryLabel: 'Forecast Quality Scoring',
  icon: '🌅',
  description: 'Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.',
  scoreDescription: `• 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.
• 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.
• 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.
• 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.
• 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.
• 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.`,
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf'],
  outputModels: ['gw_v2_blend_50', 'gw_v2_hrrr', 'gw_v2_rrfs', 'gw_v2_rdps', 'gw_v2_gfs', 'gw_v2_ecmwf', 'gw_nowcast'],
  config: {
    defaultModel: 'gw_v2_blend_50',
    defaultOpacity: 0.8
  }
};

export default sunriseDefinition;
